import { httpClientSessionManager } from 'dashboard-experience/shared/services'

import { type SessionStoneAccountResponse } from '../entities'

export const getStoneAccount = async ({ globalId = '' }) => {
  const response = await httpClientSessionManager<SessionStoneAccountResponse>({
    url: '/api/v1/session-manager/web/session/stone-account',
    method: 'GET',
    params: {
      current_stone_account_id: globalId
    }
  })

  return response.data
}
